import React from 'react';
import { Section, Heading, Grid } from '@radix-ui/themes';
import { Device, ValidationError } from '../../types';
import { useDevices } from '../../contexts/DeviceContext';
import DeviceCard from '../DeviceCard';
import './DeviceList.css';

interface DeviceListProps {
  onEditDevice: (device: Device) => void;
  issues: ValidationError[];
}

const DeviceList: React.FC<DeviceListProps> = ({ onEditDevice, issues }) => {
  const { devices } = useDevices();

  const getDeviceIssue = (deviceId: string): string | undefined => {
    const deviceIssues = issues.filter(i => i.deviceId === deviceId);
    if (deviceIssues.length === 0) return undefined;
    return deviceIssues.map(i => i.message).join('; ');
  };

  if (devices.length === 0) {
    return null;
  }

  return (
    <Section size="1" className="device-list">
      <Heading size="6" mb="4">All Devices ({devices.length})</Heading>
      <Grid columns={{ initial: '1', sm: '2', lg: '3' }} gap="4" className="device-grid">
        {devices.map(device => (
          <DeviceCard
            key={device.id}
            device={device}
            onEdit={onEditDevice}
            hasIssue={issues.some(i => i.deviceId === device.id)}
            issueMessage={getDeviceIssue(device.id)}
          />
        ))}
      </Grid>
    </Section>
  );
};

export default DeviceList;
